import { combineReducers } from 'redux';
import {

    GET_PROMOTIONS_LOADING,
    GET_PROMOTIONS_SUCCESS,
    GET_PROMOTIONS_ERROR,

} from './actions'

const initialStateObject = {
    loading: false, data: {}, error: ""
}

const promotions = (state, action) => {
    if (typeof state === 'undefined') {
        return initialStateObject
    }
    switch (action.type) {
        case GET_PROMOTIONS_LOADING: {
            return {
                loading: true,
                data: {},
                error: ""
            }
        }
        case GET_PROMOTIONS_SUCCESS: {
            return {
                loading: false,
                data: action.data,
                error: ""
            }
        }
        case GET_PROMOTIONS_ERROR: {
            return {
                loading: false,
                data: {},
                error: action.errorMessage
            }
        }
        default:
            return state
    }
};

export default combineReducers({
    promotions
});